import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { SectionService } from '../_services/section.service';
import { ProfileService } from '../_services/profile.service';
import { catchError, map, of, switchMap, from, Observable } from 'rxjs';
import { NotificationAlertService } from '../_services/notification-alert.service';

export const sectionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const sectionsService = inject(SectionService);
  const profileService = inject(ProfileService);
  const router = inject(Router);
  const notificationAlertService = inject(NotificationAlertService);

  const section = route.data['section'];

  return from(profileService.getLoggedRoleName()).pipe(
    switchMap(roleName =>
      sectionsService.loadSections().pipe(
        map((res: any) => {
          if (
            res?.Sections?.[section] ||
            roleName == 'admin' ||
            (section == 'impostazioni' &&
              ['admin', 'project_manager', 'hr_manager'].includes(roleName))
          ) {
            return true;
          }
          notificationAlertService.responseToast(
            'error',
            'Non puoi accedere a questa sezione'
          );
          return router.parseUrl('/dashboard/bacheca');
        }),
        catchError(() => {
          notificationAlertService.responseToast(
            'error',
            'Errore durante il controllo sezione'
          );
          return of(router.parseUrl('/dashboard/bacheca'));
        })
      )
    )
  );
};
